import { Container } from 'react-bootstrap';
import { Upload } from '../FormFields/Upload';
import { ControlButtons } from '../ControlButtons';
import { useState } from 'react';

export const ATFLicense = ({
	currLicence = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const [currFile, setCurrFile] = useState(currLicence.file);
	const [currAnswer, setCurrAnswer] = useState(currLicence.answer);
	return (
		<>
			<Container className="mt-5 component">
				<h2>Do you have your current ATF License?</h2>
				<p>
					If you don't upload your ATF License in your application, you must
					come bring one in person.
				</p>

				<Upload
					file={currFile}
					setFile={setCurrFile}
					answer={currAnswer}
					setAnswer={setCurrAnswer}
				/>
			</Container>
			<Container>
				<ControlButtons
					onSubmit={() => onSubmit({ file: currFile, answer: currAnswer })}
					onNext={() => onNext({ file: currFile, answer: currAnswer })}
					onPrev={onPrevious}
					finalStep={finalStep}
					disableNext={currAnswer === null || (currAnswer && !currFile)}
					disablePrev={disablePrev}
				/>
			</Container>
		</>
	);
};
